export default function Haiku() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">
        <a
          href="https://instagram.com/real.haiku"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 underline hover:text-blue-600"
        >
          @Real.Haiku
        </a> on Instagram
      </h1>
      <iframe
        src="https://snapwidget.com/embed/1120231"
        className="snapwidget-widget"
        allowTransparency="true"
        style={{ border: "none", overflow: "hidden", width: "100%", maxWidth: "100%",  height: "80vh" }}
        title="Posts from @Real.Haiku on Instagram"
      ></iframe>
    </div>
  );
}